export default __webpack_public_path__ + "static/media/mongo.b9e24b8b.png";